import React from "react";

export default () => (
  <span
    style={{
      borderLeft: "1px solid #ccc",
      paddingLeft: "3px",
      marginLeft: "5px",
      height: "13px"
    }}
  >
    <span
      style={{
        fontSize: "13px",
        color: "#777"
      }}
      className="material-icons"
    >
      public
    </span>
  </span>
);
